import styled from "styled-components";

export const MapAreaViewContainer = styled.div<{ $sideBySide?: boolean }>`
  display: flex;
  flex-direction: ${({ $sideBySide }) => ($sideBySide ? "row" : "column")};
  align-items: ${({ $sideBySide }) => ($sideBySide ? "center" : "stretch")};
  justify-content: ${({ $sideBySide }) =>
    $sideBySide ? "space-between" : "flex-start"};
  gap: ${({ $sideBySide }) => ($sideBySide ? "16px" : "24px")};
`;

export const DriverList = styled.div<{ $fillRow?: boolean }>`
  display: flex;
  flex-direction: column;
  ${({ $fillRow }) => ($fillRow ? "flex: 1; min-width: 0;" : "")}
`;

export const DriverListRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};

  &:last-child {
    border-bottom: none;
  }
`;

export const DriverListRowContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
`;
